import { useEffect, useRef } from 'react';
import { useIsMobile } from 'hooks/useIsMobile';

export const useTableViewMobile = ({ setSelectedColumns, columnDefinition }) => {
  const isMobile = useIsMobile();
  const initialized = useRef(false);
  const oldIsMobile = useRef(isMobile);

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
    } else if (oldIsMobile.current !== isMobile) {
      oldIsMobile.current = isMobile;

      if (window.innerWidth <= 992) {
        setSelectedColumns(
          columnDefinition.map((item) => ({
            ...item,
            pinned: false,
          })),
        );
      } else {
        setSelectedColumns(
          columnDefinition.map((item) => ({
            ...item,
            pinned: item.accessor === 'name' ? 'left' : false,
          })),
        );
      }
    }
  }, [isMobile, columnDefinition, setSelectedColumns]);
};
